module.exports = __webpack_public_path__ + "static/media/salesforce-logo.e09262f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salesforce-logo.svg
// module id = 354
// module chunks = 1